export default "__VITE_ASSET__DKoTp7qC__"